import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";

export const responseErrorInterceptor = (error: unknown) => {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (error instanceof AxiosError) {
    if (error.code === "ERR_CANCELED") {
      return Promise.reject(error);
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response?.data?.errors?.[0]?.detail;

      switch (status) {
        case 401: {
          localStorage.removeItem("token");
          localStorage.removeItem("refersh");
          toast.error(message || "شما نشست معتبری ندارید", {
            onClose: () => {
              window.dispatchEvent(new Event("unauthorized"));
            },
          });
          break;
        }

        case 403: {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          toast.error(message || "شما دسترسی لازم را ندارید", {
            onClose: () => {
              window.dispatchEvent(new Event("unauthorized"));
            },
          });
          break;
        }

        case 404: {
          toast.error(message || "مورد مورد نظر پیدا نشد");
          break;
        }

        default: {
          toast.error(message || "خطای ناشناخته از سرور");
        }
      }
    } else if (error.request) {
      toast.error("خطا در ارتباط با سرور");
    } else {
      toast.error("خطای غیرمنتظره در درخواست");
    }
  } else {
    toast.error("خطای ناشناخته");
  }

  return Promise.reject(error);
};